<template>
  <div>
    <ul class="header" ref="headerHeight">
      <li @click="isactive = 1" :class="{ active: isactive == 1 }">
        <router-link to="/" exact>
          <div class="header_img">
            <img src="images/images/sy1_a.png" ref="imga" alt />
          </div>
          <p class="header_title">首页</p>
        </router-link>
      </li>
      <li>
        <router-link to="/course?from=0&n=1">
          <div class="header_img">
            <img src="images/images/kc1_a.png" ref="imgb" alt />
          </div>
          <p class="header_title">课程</p>
        </router-link>
      </li>
      <li>
        <router-link to="/teacher" exact>
          <div class="header_img">
            <img src="images/images/js1_a.png" ref="imgc" alt />
          </div>
          <p class="header_title">讲师</p>
        </router-link>
      </li>
      <li v-show="showLive">
        <router-link to="/live" exact>
          <div class="header_img">
            <img src="images/images/zt.png" ref="imgd" alt />
          </div>
          <p class="header_title">直播</p>
        </router-link>
      </li>
      <!-- <li v-show="!showLive">
        <router-link to="/introduce" exact>
          <div class="header_img">
            <img src="images/images/ztc1_a.png" ref="imgf" alt />
          </div>
          <p class="header_title">功能为引</p>
        </router-link>
      </li> -->
      <li>
        <router-link to="/myvideo" exact>
          <div class="header_img">
            <img src="images/images/wd1_a.png" ref="imge" alt />
          </div>
          <p class="header_title">我的课程</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { getCookie } from "@/utils/util";
export default {
  name: "Header",
  data() {
    return {
      current: "",
      isactive: 1,
      showLive: true
    };
  },
  mounted() {
    this.showLive = getCookie("isPaidvideoLive");
    this.getParams();
    var ua = navigator.userAgent;
    if (ua.match(/(iPad).*OS\s([\d_]+)/i)) {
      this.$refs.headerHeight.style.bottom = 0.25 + "rem";
    }
  },
  watch: {
    $route: "getParams"
  },
  methods: {
    getParams() {
      this.current = this.$route.path;
      if (this.current == "/") {
        this.$refs.imga.src = "./images/images/sy1.png";
      } else if (this.current == "/course") {
        this.$refs.imgb.src = "./images/images/kc1.png";
        this.isactive = 0;
      } else if (this.current == "/teacher") {
        this.$refs.imgc.src = "./images/images/js1.png";
        this.isactive = 0;
      } else if (this.current == "/live") {
        this.$refs.imgd.src = "./images/images/za.png";
        this.isactive = 0;
      } else if (this.current == "/introduce") {
        this.$refs.imgf.src = "./images/images/ztc1.png";
        this.isactive = 0;
      } else {
        this.$refs.imge.src = "./images/images/wd1.png";
        this.isactive = 0;
      }
    }
  }
};
</script>
<style scoped>
.header {
  position: fixed;
  bottom: 0;
  width: 7.1rem;
  /* height: 0.71rem; */
  height: 47px;
  /* padding: 0.1rem 0.2rem 0.1rem; */
  padding: 0 0.2rem;
  padding-top: 6px;
  font-size: 0.26rem;
  background-color: #fff;
  border-top: 1px solid #f2f2f2;
}
.header li {
  display: inline-block;
  /* width: 1.42rem; */
  width: 1.62rem;
}
.header_img {
  width: 0.59rem;
  height: 0.44rem;
  /* padding-left: 0.43rem; */
  padding-left: 0.5rem;
}
.header_img img {
  width: 100%;
  height: 100%;
}
.header_title {
  height: 0.46rem;
  line-height: 0.46rem;
  text-align: center;
  color: #6f6f6f;
  font-size: 0.26rem;
}
.router-link-exact-active p {
  color: #f5601a;
}
.router-link-active p {
  color: #f5601a;
}
.active p {
  color: #f5601a;
}
</style>
